import { Component, Injector, ViewEncapsulation, ViewChild, OnInit, OnDestroy } from '@angular/core';
import {
    BasketArticleDto
} from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';

import { appModuleAnimation } from '@axilla/axilla-shared';
import * as _ from 'lodash-es';

import { Table } from 'primeng/table';
import { Paginator } from 'primeng/paginator';
import { LazyLoadEvent } from 'primeng/api';

import { WebshopService } from '@app/shared/common/shop-system/services/webshop.service';
import { BasketArticleExtendedDto } from '../../../shared/common/shop-system/models/models';

@Component({
    selector: 'app-backorder-basket',
    templateUrl: './backorder.component.html',
    styleUrls: ['./backorder.component.less'],
    encapsulation: ViewEncapsulation.None,
    animations: [appModuleAnimation()]
})
export class BackorderComponent extends AppComponentBase implements OnInit, OnDestroy {

     constructor(
        injector: Injector,
        private _webshopService: WebshopService
    ) {
        super(injector);
    }

    get backorderBasket(): BasketArticleDto[] {
        return this._webshopService.backorderBasket;
    }

    get isDisabled(): boolean {
        if (this.saving) {
            return true;
        }

        return !(this.basket && this.basket.length > 0);
    }

    @ViewChild('dataTable', { static: true }) dataTable: Table;
    @ViewChild('paginator', { static: true }) paginator: Paginator;

    isLoading = false;
    saving = false;

    updateBackorderBasketSubscription$;

    ngOnInit(): void {
        this._onBackorderBasketUpdate();

        this.getBasket();
    }

    ngOnDestroy(): void {
        this.updateBackorderBasketSubscription$.unsubscribe();
    }

    private _onBackorderBasketUpdate() {
        this.updateBackorderBasketSubscription$ = this._webshopService.basketUpdate$
            .subscribe((items: BasketArticleDto[]) => {
                this.setDataTable();
            });
    }

    getBasket(event?: LazyLoadEvent) {
        this.setDataTable();
    }

    setDataTable() {
        if (this.backorderBasket || this.backorderBasket.length >= 0) {
            this.primengTableHelper.records = this.backorderBasket;
            this.primengTableHelper.totalRecordsCount = this.backorderBasket.length;
        }
    }

    remove(item: BasketArticleDto) {
        if (item) {
            this._webshopService.removeFromBackorder(item.id);
        }
    }

    changeAmountInBasket(article: BasketArticleExtendedDto) {
        this._changeAmountInBasket(article);

    }

    private _changeAmountInBasket(article: BasketArticleExtendedDto) {
        if (+article.quantity <= 0) {
            this._webshopService.removeFromBackorder(article.id);
            return;
        }

        const item = _.cloneDeep(article);
        this._webshopService.changeBackOrderItem(item);
    }

    confirmChangingItemCount(article: BasketArticleExtendedDto) {
        this.changeAmountInBasket(article);
    }
}
